export default __webpack_public_path__ + "static/media/postgresql.9f8f5cd9.png";